import { addMinutes, OwaDate, owaDate, differenceInMinutes } from 'owa-datetime';
import { OwaDateRange } from 'owa-datetime-utils/lib/OwaDateRange';
import owaDateFromTzDateTimeValues from './owaDateFromTzDateTimeValues';

/**
 * This function returns new start and end time based the change of the start date
 * It updates the start date and not the time
 * Preserves meeting duration by moving end based on new start date/time
 */

export default function getDatesOnStartDateChanged(
    prevStartDate: OwaDate,
    prevEndDate: OwaDate,
    newDate: OwaDate
): OwaDateRange {
    if (prevStartDate && prevEndDate && newDate) {
        let meetingDuration = differenceInMinutes(prevEndDate, prevStartDate);
        let newStart = owaDateFromTzDateTimeValues(prevStartDate.tz, newDate, prevStartDate);
        let newEnd = owaDate(prevEndDate.tz, addMinutes(newStart, meetingDuration));

        return {
            start: newStart,
            end: newEnd,
        };
    }
    return null;
}
